"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ForecastSimulationConflictNodeDTO_1 = require("../model/ForecastSimulationConflictNodeDTO");

var ForecastSimulationConflictNodeDTOConverter_1 = require("./ForecastSimulationConflictNodeDTOConverter");
/**
 * @author Tomas Leity
 */


var ForecastSimulationConflictNodeDTOConverterImpl =
/*#__PURE__*/
function (_ForecastSimulationCo) {
  _inherits(ForecastSimulationConflictNodeDTOConverterImpl, _ForecastSimulationCo);

  function ForecastSimulationConflictNodeDTOConverterImpl() {
    _classCallCheck(this, ForecastSimulationConflictNodeDTOConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(ForecastSimulationConflictNodeDTOConverterImpl).apply(this, arguments));
  }

  _createClass(ForecastSimulationConflictNodeDTOConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new ForecastSimulationConflictNodeDTO_1.ForecastSimulationConflictNodeDTO(conversions.toClassReferenceId(source.id), source.externalId, source.name);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      return {
        id: conversions.toDocumentReferenceId(source.id),
        externalId: source.externalId,
        name: source.name
      };
    }
  }]);

  return ForecastSimulationConflictNodeDTOConverterImpl;
}(ForecastSimulationConflictNodeDTOConverter_1.ForecastSimulationConflictNodeDTOConverter);

exports.ForecastSimulationConflictNodeDTOConverterImpl = ForecastSimulationConflictNodeDTOConverterImpl;